export const operators = {
  comparison: ['greater_than_equal', 'greater_than', 'less_than_equal', 'less_than'],
  contains: ['in', 'not_in', 'all'],
  equality: ['equals', 'not_equals'],
  geo: ['near'],
  geojson: ['within', 'intersects'],
  partial: ['like', 'contains'],
}
